import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=5847fe5f&scoped=true"
var script = {}
import style0 from "./Welcome.vue?vue&type=style&index=0&id=5847fe5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847fe5f",
  null
  
)

export default component.exports